import React from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';

export default function PublicNav({ scrolled }) {
  const { pathname } = useLocation();

  const isActive = (path) =>
    pathname === path || (path !== '/' && pathname.startsWith(path));

  return (
    <nav id="navbar" className={scrolled ? 'scrolled' : ''}>
      <Link to="/" className="nav-logo">
        <img src="/images/kayasparsha-logo.png" alt="KayaSparsha" />
      </Link>

      <ul className="nav-links">
        <li><NavLink to="/about"      className={isActive('/about')      ? 'active' : ''}>About</NavLink></li>
        <li><NavLink to="/services"   className={isActive('/services')   ? 'active' : ''}>Services</NavLink></li>
        <li><NavLink to="/treatments" className={isActive('/treatments') ? 'active' : ''}>Treatments</NavLink></li>
        <li><NavLink to="/packages"   className={isActive('/packages')   ? 'active' : ''}>Packages</NavLink></li>
        <li><NavLink to="/doctor"     className={isActive('/doctor')     ? 'active' : ''}>Our Doctor</NavLink></li>
        <li><NavLink to="/contact"    className={isActive('/contact')    ? 'active' : ''}>Find Us</NavLink></li>
      </ul>

      <Link to="/enquiry" className={`nav-cta${isActive('/enquiry') ? ' active' : ''}`}>Place Enquiry</Link>
    </nav>
  );
}
